import React, { createContext } from 'react'
import { FaMapMarkerAlt } from 'react-icons/fa';
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';
import { useAppCtx } from './app-ctx';

import Stars from './Stars';
import Slideshow from './slide-show';
import ImageMatrix from './image-matrix';
import ResortFeaturesList from './resort-feaure-list';
import RoomTypes from './resort-room-types';
import './resort-details-short-v2.css';


/**
 * 
        $resortModel->resort_id = $resortData->resort_id;
        $resortModel->name = $resortData->name;
        $resortModel->stars = $resortData->stars;
        $resortModel->address = $resortData->address;
        $resortModel->treatment_from = $resortData->treatment_from;
        $resortModel->city_id = $resortData->city_id;
        $resortModel->city_name = $resortData->city_name;
        $resortModel->region_id = $resortData->region_id;
        $resortModel->region_name = $resortData->region_name;
        $resortModel->attrs = $resortData->attrs;

        $resortModel->rooms = $resortData->rooms;
        $resortModel->descriptionsRaw = $resortData->descriptions;

            $resortModel->description = $desc->description;
            $resortModel->descriptionRooms = $desc->description;
            $resortModel->descriptionBoardings = $desc->description;
            $resortModel->descriptionServices = $desc->description;
            $resortModel->descriptionAdditionalServices = $desc->description;
            $resortModel->descriptionTreatmentServices = $desc->description;
            $resortModel->descriptionCancellationPolicy = $desc->description;
            
        $resortModel->imagesRaw = [ { // all images
                            resort_id;
                            relation,
                            filename,
                            path,
                            mime 
                    },
                    ....
        ]
        $resortModel->images = [ {  // all images except main (one with 'relation' == 0)
                resort_id;
                relation,
                filename,
                path,
                mime 
            },
            ...
        ]
        $resortModel->mainImage = {
            resort_id;
            relation
            filename 
            path
            mime ;
        }
 * */


const ResortDetailsShort = ({theResort}) => {
    const { t } = useTranslation();

    //console.log('ResortDetailsShort(): theResort=', JSON.stringify(theResort));

    return (
        <>
            <div className='address-description-rooms-wrapper'>
                <h1><span>{theResort.name}</span> <Stars rating={theResort.stars} maxStars={5}/></h1>
                <address><FaMapMarkerAlt style={{ color: '#4a4a4a', marginRight: 6, verticalAlign: '-0.1em' }} />{theResort.address}</address>
            </div>

            <div className='main-description'>
                <div className='main-image-wrapper'>
                    <Slideshow images={theResort.imageUrlsAll} autoPlay={true} interval={3000} transition="slide" 
                        showArrows={false} showDots={false} showButton={false} />
                </div>
                <div className='features-wrapper'>
                    <div>
                        <h6 className='topic'><img src={theResort.icons['features']} alt="features" className="topic-icon " />
                            <span>{t('Features')}</span></h6>
                        <ResortFeaturesList features={theResort.features} />
                    </div>
                </div>
            </div>

            <div className='description-wrapper'>
                <h6 className='topic'><img src={theResort.icons['description']} alt="description" className="topic-icon " />
                    <span>{t('Description')}</span></h6>
                <div className='p' dangerouslySetInnerHTML={{ __html: theResort.description }} />
            </div>
        
        </>
    );
}

export default ResortDetailsShort;
